/* eslint-disable jira/filename-case */
export const AriGraphSortOrderInput = {
	ASC: 'ASC',
	DESC: 'DESC',
} as const;

export type AriGraphSortOrderInput =
	(typeof AriGraphSortOrderInput)[keyof typeof AriGraphSortOrderInput];

interface AriGraphDateRangeFilterInput {
	gt?: string;
	gte?: string;
	lt?: string;
	lte?: string;
}

interface AriGraphSortInput {
	order?: AriGraphSortOrderInput;
	priority?: number;
}

export interface AriGraphFilter<T> {
	notValues?: T[];
	sort?: AriGraphSortInput;
	values?: T[];
}

interface AriGraphDateRangeFilter {
	range?: AriGraphDateRangeFilterInput;
	sort?: AriGraphSortInput;
}

type AriGraphBaseFilter = {
	createdAt?: AriGraphDateRangeFilter;
	lastUpdated?: AriGraphDateRangeFilter;
	lastModified?: AriGraphDateRangeFilter;
};

type AriGraphInner<T> = AriGraphBaseFilter & T;

type AriGraphFilterAnd<T> = {
	or?: AriGraphInner<T>[];
} & AriGraphInner<T>;

type AriGraphFilterOr<T> = {
	and?: AriGraphInner<T>[];
} & AriGraphInner<T>;

export type AriGraphFilterShape<T> = {
	and?: AriGraphFilterAnd<T>[];
	or?: AriGraphFilterOr<T>[];
};

interface GraphStoreDateRangeFilter {
	before?: string;
	after?: string;
}

export interface GraphStoreFilter<T> {
	isNot?: T[];
	is?: T[];
}

type GraphStoreBaseFilter = {
	createdAt?: GraphStoreDateRangeFilter;
	lastModified?: GraphStoreDateRangeFilter;
};

type GraphStoreInner<T> = GraphStoreBaseFilter & T;
export type GraphStoreFilterShape<T> = {
	and?: GraphStoreInner<T>[];
	or?: GraphStoreInner<T>[];
};

export interface GraphStoreSort {
	direction: AriGraphSortOrderInput;
	priority: number;
}

type GraphStoreBaseSort = {
	createdAt?: GraphStoreSort;
	lastModified?: GraphStoreSort;
};

export type GraphStoreSortShape<T> = GraphStoreBaseSort & T;
